var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorVectorBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m12,12c3.309,0 6,-2.691 6,-6S15.309,0 12,0s-6,2.691 -6,6 2.691,6 6,6ZM12,1c2.757,0 5,2.243 5,5s-2.243,5 -5,5 -5,-2.243 -5,-5S9.243,1 12,1ZM12,14c-4.963,0 -9,4.037 -9,9v0.5c0,0.276 0.224,0.5 0.5,0.5s0.5,-0.224 0.5,-0.5v-0.5c0,-2.953 1.613,-5.532 4,-6.918v2.989c-0.86,0.224 -1.5,1 -1.5,1.929 0,1.103 0.897,2 2,2s2,-0.897 2,-2c0,-0.929 -0.64,-1.705 -1.5,-1.929v-3.482c0.927,-0.377 1.939,-0.589 3,-0.589s2.073,0.212 3,0.589v3.462c-1.14,0.232 -2,1.242 -2,2.449v2c0,0.276 0.224,0.5 0.5,0.5s0.5,-0.224 0.5,-0.5v-2c0,-0.827 0.673,-1.5 1.5,-1.5s1.5,0.673 1.5,1.5v2c0,0.276 0.224,0.5 0.5,0.5s0.5,-0.224 0.5,-0.5v-2c0,-1.208 -0.86,-2.217 -2,-2.449v-2.968c2.387,1.386 4,3.964 4,6.918v0.5c0,0.276 0.224,0.5 0.5,0.5s0.5,-0.224 0.5,-0.5v-0.5c0,-4.963 -4.037,-9 -9,-9ZM9.5,21c0,0.552 -0.448,1 -1,1s-1,-0.448 -1,-1 0.448,-1 1,-1 1,0.448 1,1Z",
    id: "path_0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorVectorBlack);
export default __webpack_public_path__ + "static/media/doctor_vector_black.bdbff7f78949dbf7126fd4e46b9e4055.svg";
export { ForwardRef as ReactComponent };